const Key = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M56 -0.000244141H8C3.58172 -0.000244141 0 3.58148 0 7.99976V56C0 60.4183 3.58172 64 8 64H56C60.4183 64 64 60.4183 64 56V7.99976C64 3.58148 60.4183 -0.000244141 56 -0.000244141Z"
      fill="#FFCCEF"
    />
    <rect
      x="45.1201"
      y="41.7065"
      width="9.3867"
      height="9.49335"
      transform="rotate(90 45.1201 41.7065)"
      fill="#0A0777"
    />
    <rect
      x="27.3068"
      y="35.8401"
      width="9.38669"
      height="22.7201"
      fill="white"
    />
    <ellipse cx="32.0001" cy="21.8662" rx="16.32" ry="16.3201" fill="#FB6E44" />
    <path
      d="M32.0001 28.7994C35.8293 28.7994 38.9335 25.6952 38.9335 21.866C38.9335 18.0368 35.8293 14.9326 32.0001 14.9326C28.1709 14.9326 25.0668 18.0368 25.0668 21.866C25.0668 25.6952 28.1709 28.7994 32.0001 28.7994Z"
      fill="#FFCCEF"
    />
  </svg>
);

export default Key;
